import { gql } from '@apollo/client';

import { CREATE_ADS_WITH_CREATIVES_CREATIVE_ENTITY_FIELDS } from './createAdsWithCreativesCreativeEntityFields';
import { CREATE_ADS_WITH_CREATIVES_OPERATION_ERROR_FIELDS } from './createAdsWithCreativesOperationErrorFields';

export const CREATE_ADS_WITH_CREATIVES_CREATIVE_ITEM_FIELDS = gql`
  fragment CreateAdsWithCreativesCreativeItemFields on CreateAdsWithCreativesCreativeItem {
    operationStatus
    error {
      ...CreateAdsWithCreativesOperationErrorFields
    }
    creativeEntity {
      ...CreateAdsWithCreativesCreativeEntityFields
    }
  }
  ${CREATE_ADS_WITH_CREATIVES_OPERATION_ERROR_FIELDS}
  ${CREATE_ADS_WITH_CREATIVES_CREATIVE_ENTITY_FIELDS}
`;
